import React, { useEffect, useState } from "react";
import PartnerCompany from "../../../../AllPageComponents/PartnerCompany/PartnerCompany";
import FAQ from "../../../../AllPageComponents/FAQ/FAQ";
import { Link } from "react-router-dom";
import FastImage from "../../../../FastImage";
import { auto } from "@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core";
import Redirect from "../../../../AllPageComponents/Rederict";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { MdOutlineExpandMore } from "react-icons/md";
import { IoMdAddCircle } from "react-icons/io";
import DocumentForHealthInsurence from "../../HealthInsurePage/HealthInsureComponents/DocumentForHealthInsurence";
import { Helmet } from "react-helmet-async";

const IndividualHealthInsurance = () => {
  const initialText =
    "With Beema1, get top-rated health insurance plans online. You can compare online and buy the most suitable insurance plan for you and your family. You can also get your queries answered by our team of experts.";

  const [showFullText, setShowFullText] = useState(false);

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };

  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const highlight = [
    {
      id: 0,
      Q: "Insurance Coverage",
      A: "An individual health insurance policy offers coverage only for the person insured. Based on the terms and conditions of the individual health insurance policy, the insurer pays off a certain sum of the medical treatment expenses incurred by the policyholder.",
    },
    {
      id: 1,
      Q: " Co-Payment",
      A: "For certain medical-care services, the insured individual must spend a stated fee, which is named or labeled co-payment.",
    },
    {
      id: 2,
      Q: "Quick Claim Settlement",
      A: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer too Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer too",
    },
    {
      id: 3,
      Q: "The Inclusions",
      A: "An individual medical insurance plan covers both pre and post hospitalization expenses depending on the policy term. Most of the individual health insurance plans cover expenses of room rent, doctor’s fee, operation expenses, and medical investigation costs.",
    },
    {
      id: 4,
      Q: "Renewing Your Individual Health Policy",
      A: "Individual health insurance policies have a specialized feature of lifetime renewability to keep you covered for an extended period.",
    },
    {
      id: 5,
      Q: "Additional Coverage",
      A: "Coverage for critical illnesses can be availed with individual health insurance policies.",
    },
  ];

  const [Readmore, setReadmore] = useState(true);
  const handelReadmore = () => {
    setReadmore(!Readmore);
  };

  const [readmoretwo, setreadmoretwo] = useState(true);
  const handelreadmore = () => {
    setreadmoretwo(!readmoretwo);
  };

  const [activTab, setactivTab] = useState(1);
  const [tabulerindividual, settabulerindividual] = useState(1);

  const [readmoreTab, setreadmoreTab] = useState(true);
  const handlreadtwo = () => {
    setreadmoreTab(!readmoreTab);
  };

  return (
    <>
      <section className="car-insurance insurance-all main-health mainnargin-insurance">
        <div className="container">
          <Redirect />
          <div className="row insurance-row-one">
            <div className="col-sm-12 col-md-4 col-lg-4 mian-one ">
              <div className="healthdiscription">
                {/* <h1>Individual health insurence Policy </h1> */}
                <h1>
                  Individual health Policies with Specialized Insurance Packages
                </h1>
                <div>
                  <span style={{ textAlign: "justify" }}>{initialText}</span>
                </div>
              </div>
              <div className="insurance-btn-set">
                <button
                  type="button"
                  className="reminderbutton"
                  data-toggle="modal"
                  data-target="#reminderpopup"
                >
                  {" "}
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fontSize="15pt"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: "rgb(251, 167, 27)", margin: "0px 5px" }}
                  >
                    <circle cx={12} cy={13} r={8} />
                    <path d="M12 9v4l2 2" />
                    <path d="M5 3 2 6" />
                    <path d="m22 6-3-3" />
                    <path d="M6.38 18.7 4 21" />
                    <path d="M17.64 18.67 20 21" />
                  </svg>{" "}
                  Set Reminder
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 side-image">
              <FastImage
                url={
                  "Website%20Img/mascot_image1678942204.png?updatedAt=1718776425936"
                }
                width={auto}
                height={auto}
                alt={"arrow"}
                src={
                  "Website%20Img/mascot_image1678942204.png?updatedAt=1718776425936"
                }
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 popup-main">
              <div className="form-main">
                <form id="insurance_form_get_plan">
                  <div className="d-flex align-items-center form-input">
                    <h6>
                      Compare &amp; Buy Customized Health Plans starting at just
                      <span className="specialprice">Rs ₹257/month*</span>
                    </h6>
                    <div className="blue-btn">
                      <Link to={"/healthStep1"}>
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            color: "white",
                            fontWeight: 400,
                          }}
                        >
                          Get Your Quotes
                        </button>{" "}
                        <img alt="" src="" className="" />
                      </Link>
                    </div>
                    <p className="insurance-text-light">
                      By clicking, I agree to{" "}
                      <a href="/termsandcondition">*terms &amp; conditions</a>{" "}
                      and <a href="/privacy-policy">privacy policy</a>.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="inbulitmargine"></div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Why One Must Buy Individual Health Insurance Plan ?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12 d-flex justify-content-center align-items-center">
              <p className="textformat">
                Health insurance is known in various forms, but their main aim
                is to provide the policyholder with adequate and competent
                financial coverage against the ever-booming medical inflation.
                When it’s the question of an individual health insurance
                coverage and family health insurance policy, there are certain
                differences. You should know how to analyze and decide which
                plan is more suitable and useful for you! In a normal course,
                the premium rate is decided by the policyholder's age, gender,
                medical history, and many other different factors. Availing of
                such plans, you can get a more encyclopedic and all-inclusive
                coverage that is custom-made based on prioritization, according
                to your specific requirements and health status. Moreover, add-
                on covered can be bought to broaden and bolster the coverage of
                the individual health insurance plan.
              </p>
            </div>
            {/* <div className="col-md-6 col-12 d-flex justify-content-center align-items-center"> 
                  <FastImage url='/Website%20Img/Self%20confidence-rafiki.png?updatedAt=1721733304032' width={auto} height={auto} className='fmailimagegifs'/>
                </div> */}
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Highlighted Features Of An Individual Health Insurance{" "}
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                {highlight.map((data, index) => {
                  return (
                    <Accordion
                      expanded={expanded === `panel${data.id}`}
                      onChange={handleChange(`panel${data.id}`)}
                    >
                      <AccordionSummary
                        expandIcon={<MdOutlineExpandMore />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        className="accordingback"
                      >
                        <div>
                          <IoMdAddCircle
                            style={{
                              color: "#2959B8",
                              marginLeft: "5px",
                              marginRight: "5px",
                            }}
                            fontSize={"15pt"}
                          />
                        </div>
                        <div>
                          <li className="listcol">{data.Q}</li>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="textformat">{data.A}</p>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </div>
            </div>
            <div className="col-md-6 col-12 d-flex justify-content-center align-items-center">
              <FastImage
                url="/Website%20Img/Boost%20your%20immune%20system-rafiki.png?updatedAt=1721733619245"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            What Are The Benefits Of Availing Individual Health Insurance
            Policies
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            Individual medical insurance policies have various advantages. Let’s
            delve deep into most worthy and significant advantages listed below:
          </p>
          <div className="row">
            <div className="col-md-6">
              <div className="boxstepsenioursecond">
                <p className="textformat">
                  <span className="specialprice">
                    1.  Medical Costs Are Covered:- 
                  </span>
                  The primary and the foremost reason of buying individual
                  health insurance plan is for securing your family from
                  unanticipated medical expenses. It saves you from financial
                  erosion and if you have certain medical issues, an individual
                  health plan relieves you from the outflow of medical expenses,
                  helping you to recover without stress.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="boxstepsenioursecond">
                <p className="textformat">
                  <span className="specialprice">
                    2.  Cashless Claim Benefits:- 
                  </span>
                  If it's cashless hospitalization, the insurer pays directly to
                  the hospital. You can avail the cashless offered by the
                  insurer while medical emergency arises or when you decide for
                  hospitalization. Cashless hospitalization facility in
                  individual insurance plan set by health insurers allow insured
                  individuals to receive benefits of enjoying medical treatments
                  without paying at the hospital.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="boxstepsenioursecond">
                <p className="textformat">
                  <span className="specialprice">
                    3.  Daily Allowance for Hospitalization:- 
                  </span>
                  Certain insurers pay pre-calculated amount daily basis to the
                  hospital. This is implemented after the insured is
                  hospitalized for few days. Total days of hospitalization is
                  always pre-determined in the individual health insurance
                  policy, and it varies from one to another. This is a helpful
                  service if you are the primary earner in your family.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="boxstepsenioursecond">
                <p className="textformat">
                  <span className="specialprice">4.  Tax Benefits:- </span>
                  When one need annual tax benefits, individual health insurance
                  policy is considered. This benefits you to protect your
                  financial plans, and also your health which is your precious
                  wealth as well. Section 80D of the Income Tax Act, 1961
                  permits to reduce the premiums paid for an individual health
                  insurance coverage
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Why to Buy Individual Health Insurance Policy 
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <div
                className={Readmore ? "Readmoreindivisualhealth" : "Readless"}
              >
                <p className="textformat">
                  An Individual Health Insurance policy backs up with financial
                  support in a scenario of a single person's medical emergency.
                  These plans are accurately comprehensive by nature and can be
                  availed of to cover each individual based on the plan's entry
                  age. Individual health insurance plans can be custom-made to
                  meet one's specific needs. Opting for an individual health
                  insurance policy is tagged with certain benefits – It provides
                  full coverage for yourself, securing your medical expenses
                  with adequate coverage without sharing limits with family
                  members. You can avail tax benefits under sec 80D minimizing
                  your taxable income plus ensuring to secure your health. At
                  the time of any emergency hospitalization, you will not have
                  to get stressed out regarding finances as because the policy
                  will cover the expenses, letting you to focus on a speedy
                  recovery with peace of mind. There will be a number of
                  considerations to be noted before zeroing down on a policy.
                </p>
                <p className="textformat">
                  One should accentuate on doing his/her own study before
                  purchasing an individual health insurance policy.
                </p>
                <p className="textformat">
                  If you are the following categories, you should consider
                  buying individual health insurance:
                </p>

                <li className="liststyl2">
                  1.&nbsp; Higher health risk individuals are best suited for
                  the plan.
                </li>
                <li className="liststyl2">
                  2.&nbsp;Self-employed individuals and individuals between 18
                  years and 26 years of age can take up individual health
                  insurance plans.
                </li>
                <li className="liststyl2">
                  3.&nbsp;Uninsured individuals having number of family members.
                </li>
                <li className="liststyl2">
                  4.&nbsp;An individual who prefers a fixed sum insured over a
                  floating sum insured.
                </li>
                <li className="liststyl2">
                  5.&nbsp;Such Individuals who renew their insurance policy
                  without considering their age.
                </li>
                <li className="liststyl2">
                  6.&nbsp;A person who needs more protection and prevention than
                  a family floater plan can offer.
                </li>
                <li className="liststyl2">
                  7.&nbsp;One who preferrs fast cashless claim settlement
                  process.
                </li>
                <li className="liststyl2">
                  8.&nbsp;Students can also avail individual health insurance
                  policy.
                </li>

                <p className="textformat">
                  It is in your best interest to get an individual health
                  insurance policy after learning and comprehending the
                  benefits, exclusions and inclusions. It is important to
                  understand what your medical insurance policy covers and what
                  specialized insurance packages an individual health insurance
                  policy provides along with all the existing features and
                  benefits. It is equally crucial to meticulously understand
                  what it doesn't cover. Carefully scrutinizing the terms and
                  conditions enlisted as policy wordings before opting for the
                  coverage for the individual health insurance.
                </p>
              </div>
              <div className="redbtn">
                <div className="Readmorebtn" onClick={handelReadmore}>
                  Readmore
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Individual Health Insurance vs Family Health Insurance
          </h1>
          <div className="yellowline"></div>

          <p className="textformat">
            Even though, both individual insurance plan and family health
            insurance plan have the same target of providing insurance coverage
            for protecting and safeguarding your financial assets, your first
            and foremost prioritized asset of your life that’s your health and
            the needs of your family; there are significant differences between
            them. When you buy a policy, you should be aware and informed
            regarding the following points before selecting an individual health
            insurance plan or the best medical insurance policy for your family:
          </p>

          <div className="row">
            <div className="col-md-12">
              <div className={readmoretwo ? "readmoreindividual" : "Readless"}>
                <div className="healthtabil">
                  <table className="individualTable">
                    <thead>
                      <tr className="individualTable-header">
                        <th className="individualTable-headerCell">
                          CRITERION
                        </th>
                        <th className="individualTable-headerCell">
                          INDIVIDUAL HEALTH INSURANCE
                        </th>
                        <th className="individualTable-headerCell">
                          FAMILY HEALTH PLAN
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        {
                          criterion: "WHO IS COVERED",
                          individual: "HEALTH INSURANCE PREMIUM",
                          family: "FAMILY MEMBERS ARE COVERED",
                        },
                        {
                          criterion: "SUM INSURED",
                          individual:
                            "ONE CAN SELECT A SPECIFIC SUM INSURED TO",
                          family: "A FAMILY HEALTH INSURANCE",
                        },
                        {
                          criterion: "AFFORDABILITY",
                          individual: "HIGHER PREMIUMS",
                          family: "CONSIDERABLY LESS EXPENSIVE",
                        },
                        {
                          criterion: "ADVANTAGES",
                          individual: "COMPREHENSIVE INSURANCE COVERAGE",
                          family: "PREMIUMS ARE ECONOMICAL AS IT’S",
                        },
                        {
                          criterion: "MEMBERS",
                          individual: "COMPREHENSIVE INSURANCE COVERAGE",
                          family: "PAID ONCE FOR ALL FAMILY",
                        },
                      ].map((item, index) => (
                        <tr key={index} className="individualTable-row">
                          <td className="individualTable-cell">
                            {item.criterion}
                          </td>
                          <td className="individualTable-cell">
                            {item.individual}
                          </td>
                          <td className="individualTable-cell">
                            {item.family}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <p className="textformat">
                  A family floater health insurance plan is designed to cover
                  you and your family under a single roof contract. You can
                  count yourself and your dependents under the same policy and
                  pay a single premium for combined and connected coverage. An
                  individual insurance plan on the other hand covers a single
                  individual. Multiple people cannot be included in the same
                  plan.
                </p>

                <p className="textformat">
                  If you’re in a dilemma to decide which one to purchase, then
                  here are a few points to consider while choosing between an
                  individual policy and a family floater plan.
                </p>

                <p className="textformat">
                  <span className="specialprice">
                    {" "}
                    How About Splitting the Cover :-
                  </span>
                  Having a family floater plan, you will have to split your
                  cover with multiple people. This can be particularly difficult
                  if all the family members share the same household, the same
                  toilet etc. Here’s an example. A couple of months back, a
                  Beema1 customer contacted us explaining how they made a claim
                  involving an accident. Her husband, mother and her kid were
                  also involved in the accident as they were all travelling
                  together in the same car. All 3 of them were admitted to a
                  hospital and the total hospital bill was 9 lakhs. Fortunately,
                  she had an individual health insurance plan on her name with a
                  total cover of 20 lakhs. Hence, he did not have to pay
                  anything out of pocket. But, this scenario quite significantly
                  outlines the shared risk in an household. When all the family
                  members are living together, you may have to make multiple
                  claims at the same time. If COVID infects and upsets one
                  person in the family, it will possibly affect everyone
                  involved. Considering each individual in a family floater plan
                  doesn’t provide with separate covers, the sum insured may not
                  be sufficient. One more example which further simplifies the
                  concept
                </p>

                <li className="liststyle">
                  <span className="specialprice">
                    Family floater plan with 15 lakh coverage:-
                  </span>
                  If 4 claims are made during the same year, each totaling 5
                  lakhs, then the family floater will only cover 3 members.
                  However, 5 lakhs for each claim will be paid off to settle all
                  the 4 claims, and 5 lakhs to settle the second claim. Since,
                  the total 15 lakhs would be completely exhausted, you’ll have
                  to pay the remaining 5 lakhs out of your own pocket.
                </li>

                <li className="liststyle">
                  <span className="specialprice">
                    4 Individual plans with a sum insured of 15&nbsp;lakhs:-
                  </span>
                  If you make 4 claims during the same policy year, each claim
                  of 5 lakhs, then the individual plans will pay out 5 lakh each
                  when the claims will be raised. In effect, you won’t have to
                  pay anything out of pocket.
                </li>

                <p className="textformat">
                  Hence, if you want comprehensive protection for every family
                  member in the family, you will have to purchase individual
                  plans or a family floater plan with a large cover.
                </p>

                <p className="textformat">
                  <span className="specialprice">
                    1. How About Splitting the Cover:
                  </span>
                  Now you know that family floater plans are more
                  pocket-friendly, within your affordability when compared to
                  individual plans.
                </p>

                <li className="liststyle">
                  <span className="specialprice">
                    2. 15 lakh coverage family floater health insurance policy:
                  </span>
                  A family of 3 members, aged 50, 42 and 18 will pay an annual
                  premium of roughly Rs. 26,000 for a 15 lakh coverage family
                  floater option
                </li>

                <li className="liststyle">
                  <span className="specialprice">
                    3. Individual health insurance plans with a sum insured of
                    10 lakhs:&nbsp;
                  </span>
                  A healthy family of 3 members in the following age category,
                  one is 50 years old, another is 42 and the third member is 18
                  years of age shall pay a combined total premium of 78,000 for
                  3 individual plans with a 15lakh cover. Considering the total
                  difference in premium.
                </li>
                {/* <p className='textformat' ></p> */}

                <li className="liststyle">
                  <span className="specialprice">4. Maternity Coverage:</span>
                  If you are looking for a plan that covers maternity benefits
                  then most likely you have to buy a family floater plan. This
                  is a common feature to most of the insurance companies. They
                  expect the couple (husband and wife) to be covered in a family
                  floater plan before they stretch maternity benefits. Hence, if
                  you are looking for maternity coverage, individual plans won’t
                  cut it
                </li>

                <li className="liststyle">
                  <span className="specialprice">5. Aged Parents:</span>
                  Majority intends to avail a family floater plan for themselves
                  where their elderly parents are also included in it. However,
                  this condition does not exist in most scenarios. Most of the
                  insurers have a distinct definition of what exist in family
                  establishments, when it comes to a family floater plan.
                  Normally, this includes the husband, wife and children. The
                  children need to be younger than 21 or 25 years of age based
                  on the policy you select. Therefore, if you are trying hard in
                  exploring and choosing a health insurance plan for your aged
                  parents, you are the child. And if you’re older than 21 or 25,
                  then you may not be able to include them in the plan. In such
                  cases, you may have to avail of a family floater plan for your
                  parents (mother and father) and then an individual plan for
                  yourself
                </li>

                <li className="liststyle">
                  <span className="specialprice">
                    6. Pre-existing ailments:
                  </span>
                  If any individual member in the family has certain complicated
                  and delicate health conditions, then the insurance expertise
                  may suggest that you avail of a distict individual plan for
                  them, because these people might require policies with certain
                  specific features and family floater plans may not extend
                  them. Therefore, if somebody in your family has pre-existing
                  conditions, then, you may have to consider buying them an
                  individual plan
                </li>

                <p className="textformat">
                  <span className="specialprice">
                    7. How monotonous and tricky is the part of documentation or
                    any paperwork?
                  </span>
                  Once you determine to buy a family floater plan, you’ll only
                  need to fill out the application, submit a single proposal
                  form, pay the premiums at the same time and receive updates
                  related to an individual plan. This acts supportively
                  regarding operational load and it’s unlikely that you will
                  forget to pay your premiums on time If you’re purchasing
                  several individual insurance policies, you’ll have to fill out
                  the application number of times, submit multiple proposal
                  forms, pay the premiums multiple times and receive all updates
                  associated with all the different insurance policies you hold.
                  This is beyond your capacity to tackle single-handedly if you
                  are the only one responsible for keeping all the documents in
                  order, it might be possible, that you may also forget to pay
                  your premiums. Eventually, there are multiple factors that you
                  need to consider before making a decision between family
                  floater plans and individual policies. Before the final call,
                  one shall look into the coverage options, pricing, premium
                  pricing and the paperwork before you finalize an option.
                </p>
              </div>
              <div className="redbtn">
                <button className="Readmorebtn" onClick={handelreadmore}>
                  {readmoretwo ? "Readmore" : "Readless"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Things To Remember While Purchasing An Individual Health Insurance
            Policy
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            While it is much essential to go through the entire policy document
            before choosing a health insurance policy, here are some of the most
            basic features that you must be aware of before making the final
            decision.
          </p>

          <div className="row">
            <div className="col-md-6 mt-4">
              <div className="boxseparte">
                <div>
                  <span className="separatespan">
                    {" "}
                    Benefits That Are Customized
                  </span>

                  <p className="textformat">
                    A policyholder is free to select the level of coverage that
                    is truly beneficial for his or her medical necessities. This
                    might be decided by the policyholder's budget. An individual
                    health insurance plan can be customized by adding extra
                    coverages (add-ons).
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-4">
              <div className="boxseparte">
                <div>
                  <span className="separatespan">Personal Sum Insured</span>

                  <p className="textformat">
                    Health insurance coverage has a maximal amount that can be
                    paid out. The sum covered in a group policy have to be
                    shared with other plan members. An individual health
                    insurance plan, on the other side, allots the entire sum
                    insured to cover only the policyholder.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-4">
              <div className="boxseparte">
                <div>
                  <span className="separatespan">Cost-Effective</span>

                  <p className="textformat">
                    Individual health insurance plans are cost effective than
                    group health insurance coverage. This is because the cost of
                    a Family Floater plan, for example, is decided by the number
                    of people insured by the policy. In such cases, the expense
                    of medical insurance is restricted to the coverage and
                    services offered by the insurance company. Assigned coverage
                    is less expensive
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-4">
              <div className="boxseparte">
                <div>
                  <span className="separatespan">Waiting Period</span>

                  <p className="textformat">
                    Health Insurance Policies have waiting periods starting from
                    one year to four years (sometimes even more) for covering up
                    pre-existing diseases and some particular ailments. Within
                    this waiting period, ailments those are counted under that
                    category are not covered. At least try to go for minimum
                    waiting periods for each type.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-4">
              <div className="boxseparte">
                <div>
                  <span className="separatespan">
                    Inclusions and Exclusions
                  </span>

                  <p className="textformat">
                    Examine the policy document to determine what is covered and
                    what is excluded. This will be helpful to avoid risks,
                    shocks and headaches during the claim settlement process.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-4">
              <div className="boxseparte">
                <div>
                  <span className="separatespan">Network Hospitals</span>
                  <p className="textformat">
                    Study and stay updated about your network hospitals that
                    your insurance provider is empaneled with– Getting the
                    access to a vast and widespread network assures that you can
                    receive cashless treatment and avoid unnecessary
                    out-of-pocket expenses. Make sure that the closest hospital
                    or nursing home to your residence is empaneled in the
                    insurer’s network. This is how you don’t have to be anxious
                    about paying the hospital out-of-pocket at the time of any
                    home hospitalization.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-4">
              <div className="boxseparte">
                <div>
                  <span className="separatespan">Add-ons and Riders</span>

                  <p className="textformat">
                    Acknowledge additional benefits and perquisites such as
                    critical illness covers, accidental cover, or premium-waiver
                    benefits. These riders can provide embellished protection
                    and security plus cater to specific health requirements and
                    fulfill various medical necessities.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-4">
              <div className="boxseparte">
                <div>
                  <span className="separatespan">
                    Claim Settlement Ratio (ISR)
                  </span>

                  <p className="textformat">
                    Know about the insurance provider's CSR. The CSR indicator
                    represents the number of claims settled for every 100 claims
                    received. A higher ratio indicates a better track record of
                    settling and resolving claims, assuring reliability and
                    peace of mind. A CSR of 80-90% is decent, and a CSR of over
                    90% is stellar
                  </p>
                </div>
              </div>
            </div>

            {/* <div className="col-md-12 mt-4">
    <div className="boxseparte">
      <div>

  
      </div>
    </div>
    </div> */}
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            What Are the Different Kinds of Individual Health Insurance Policies
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            We have covered quite decently the significant features and numbers
            of individual health insurance policy that you need to read through.
            Benefits and features of some type of individual policies have been
            mentioned that serves various needs. Knowing these types can help
            you choose the best individual health policy for your prevailing
            situation
          </p>
          <div className="row">
            <div className="col-md-12">
              <div className="prosconstabular">
                <div className="scrollhiddentab">
                  <div className="scrollerindividualhealth">
                    <div
                      className={
                        activTab === 1 ? "activetabse" : "deactivetabse"
                      }
                      onClick={() => {
                        setactivTab(1);
                      }}
                    >
                      Individual Health Insurance Plan
                    </div>
                    <div
                      className={
                        activTab === 2 ? "activetabse" : "deactivetabse"
                      }
                      onClick={() => {
                        setactivTab(2);
                      }}
                    >
                      Critical Illness Health Insurance
                    </div>
                    <div
                      className={
                        activTab === 3 ? "activetabse" : "deactivetabse"
                      }
                      onClick={() => {
                        setactivTab(3);
                      }}
                    >
                      Top-ups and Super
                    </div>
                  </div>
                </div>

                {activTab === 1 && (
                  <p className="textformat">
                    This is the most common type of health insurance that offers
                    coverage for a single individual. This covers a wider
                    dimension of medical expenses, including surgery,
                    hospitalization, room-rent restrictions, including both pre
                    and post hospitalization care and medical investigation
                    expenses. These plans are most appropriate for those
                    exploring and seeking comprehensive coverage customized to
                    their healthcare needs.
                  </p>
                )}
                {activTab === 2 && (
                  <p className="textformat">
                    Critical Illness Health Insurance policy is bestowed with an
                    aggregate amount of payment for diagnosing and evaluating
                    critical illnesses such as cancer, heart attack, or stroke.
                    This lump sum global amount can be used for treatment costs
                    or any other medical expenses. These plans are crucial and
                    vital for those who are seeking financial security and
                    medical protection against massive threats of medical
                    issues, pre-existing diseases, and serious ailments.
                  </p>
                )}
                {activTab === 3 && (
                  <p className="textformat">
                    These plans are additional coverages when your existing
                    health insurance policy’s sum insured is drained out. While
                    top-up plans require each claim to surpass the deductible
                    limit, super top-up policies contemplate the total
                    hospitalization expenses within a policy year for the
                    deductible. Top-ups and STUs are affordable ways to increase
                    your coverage.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <DocumentForHealthInsurence />

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Individual Health Insurance Plans for Corporate Employees
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                Post the pandemic uproar and chaos, access and approach to
                remote work privileges have increased, and rising health scares,
                companies and enterprises worldwide are merging in more assets
                and resources towards protecting employees' all-square
                well-being. With corporate evacuations and retreats, office
                tours, and free health camps, companies are exhibiting their
                overall concern for their employees. Gradually, the number of
                organizations offering corporate health insurance plans are
                increasing in numbers, wherein, along with some additional
                charges, you may include your family as well. This is
                appreciated by the employees who are salaried individuals, more
                so, considering the flexibility of corporate health insurance
                plans, they should look forward for taking up individual health
                insurance policies for themselves, and their family members. An
                example will simplify it further - For a salaried employee, a
                corporate health insurance plan is like a premium quality slice
                of pastry at some classic signature restaurant. It surely does
                add a class to your dish, but it doesn’t satisfy your hunger!
                Hence, for the latter, you need an individual health insurance
                policy.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Salaried Individuals And Corporate Health Insurance Policies
          </h1>
          <div className="yellowline"></div>

          <p className="textformat">
            Nitin joins a Private Organization that offers excellent
            remuneration plus many perks and grands. Corporate health insurance
            plan is also a part of Nitin’s employment. The organization’s HR
            department informs him that he has 2 options - INR 10 lakhs and INR
            15 lakhs coverage, the premiums for both the purpose can be deducted
            from his salary. Nitin has the option to include in his corporate
            health insurance policy either his parents or his spouse and
            children at a moderate charge. Such a wonderful plan it is, isn’t
            it? What are the cons of such corporate plans? Take a look –
          </p>
          <div className="row">
            <div className="col-md-12">
              {/* <div className="flexdivproscornshealth">
<div className={tabulerindividual === 1 ? "activetabse" : "deactivetabse"} onClick={()=>{settabulerindividual(1)}}>Pros</div>
<div className={tabulerindividual === 2 ? "activetabse" : "deactivetabse"} onClick={()=>{settabulerindividual(2)}}>Cons</div>
</div> */}
              <div className="prosconsdiv">
                <div
                  className={
                    tabulerindividual === 1
                      ? "tabsproscons"
                      : "tabsprosconsdeactive"
                  }
                  onClick={() => {
                    settabulerindividual(1);
                  }}
                >
                  Pros
                </div>
                <div
                  className={
                    tabulerindividual === 2
                      ? "tabsproscons"
                      : "tabsprosconsdeactive"
                  }
                  onClick={() => {
                    settabulerindividual(2);
                  }}
                >
                  Cons
                </div>
              </div>

              <div className="prosconstabular">
                {tabulerindividual === 1 ? (
                  <>
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">
                          <li className="liststyle">
                            <span className="specialprice">
                              Family Inclusion at minimum charges:
                            </span>
                            For the employee’s insurance, the employer provides
                            the premium. If the employee extends this plan to
                            include his/her family members, a minimum charge for
                            the insurance premium will be added that will be
                            deducted monthly from their salary. Therefore,
                            employees and their families are financially funded
                            and supported for medical exigencies for a nominal
                            amount.
                          </li>

                          <li className="liststyle">
                            <span className="specialprice">
                              Affordable Plan:
                            </span>
                            The premium levied on corporate plans is
                            comparatively on the lower side. Since such health
                            insurance policies are offered by an enterprise
                            empaneled with the insurer, employees enjoy the
                            benefits of paying a low premium for the coverage
                            offered.
                          </li>

                          <li className="liststyle">
                            <span className="specialprice">
                              No Medical Check-up:
                            </span>
                            No pre-medical check-up is conducted before
                            enrolling under this plan.
                          </li>

                          <li className="liststyle">
                            <span className="specialprice">
                              The Premium Deduction Is Out Of The Employee’s
                              Salary:
                            </span>
                            The premium amount for the corporate plans is
                            deducted right out of their salary on a monthly
                            basis, so it doesn’t seem to be a burden for the
                            employees.
                          </li>

                          <li className="liststyle">
                            <span className="specialprice">
                              There’s No Waiting Period:
                            </span>
                            From Day 1, you and your family are covered under
                            your corporate health plan.
                          </li>

                          <li className="liststyle">
                            <span className="specialprice">
                              Pre-Existing Ailments Covered:
                            </span>
                            The insurer accepts claim settlements without
                            hassles, irrespective of any pre-existing diseases.
                          </li>
                        </div>
                      </div>
                    </div>
                  </>
                ) : tabulerindividual === 2 ? (
                  <>
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">
                          <li className="liststyle">
                            <span className="specialprice">
                              Minimal Coverage:
                            </span>
                            The coverage offered may fall short of fulfilling
                            future medical treatment expenses, especially if the
                            family is included.
                          </li>
                          <li className="liststyle">
                            <span className="specialprice">
                              Being Dependent On The Employer:
                            </span>
                            The corporate health plan is tied to your
                            employment, and ceases when you leave the company.
                          </li>
                          <li className="liststyle">
                            <span className="specialprice">
                              Portability Option Is Open, But Not Easy:
                            </span>
                            Porting your corporate plan to an individual health
                            insurance plan can be burdensome and is not highly
                            recommended.
                          </li>
                          <p className="textformat">
                            Hence, while corporate health insurance can provide
                            temporary support, it's essential to secure your own
                            individual health insurance policy for future needs.
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Why Do Salaried Individuals Need Individual Health Insurance Policy?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <div className={readmoreTab ? "Readmore" : "Readless"}>
                <p className="textformat">
                  A corporate health insurance plan is a great substitute plan
                  that comes for a nominal premium charge. However, as you
                  browse through the recent medical inflation, and you will come
                  across the expenses to avail of quality medical services. For
                  decades and ages, you need a net financial protection that
                  will be satisfactory and competent to cover all types of
                  medical treatment procedures and hospitalizations. A corporate
                  health insurance plan is to stay with you until you are an
                  employee of the organization, till the time your employment
                  lasts. Hence, it’s quite elusive and capricious to captivate
                  you, but actually it’s of no use. What happens to your
                  corporate health insurance backup if:
                  <p />
                  <li className="liststyle">
                    <span className="specialprice">
                      SCENARIO 1: You Leave The Organization
                    </span>
                    Even though, you are employed with a much-reputed
                    organization, you will always have beckoning and alluring
                    from better organizations offering you greater packages. You
                    will definitely not stick back to your previous organization
                    because you have a health insurance plan from your employer?
                    That doesn’t make any sense. So, you get deductions from
                    your salary and you pay up towards a health insurance plan
                    that stands invalid when you change your company.
                  </li>
                  <li className="liststyle">
                    <span className="specialprice">
                      SCENARIO 2: The Company Shuts Down
                    </span>
                    <p className="textformat">
                      Because of recession or steep competition among the
                      private organizations and multi-national companies closing
                      down is no surprise. In such cases, as an employee of the
                      company, you will be losing out on your corporate health
                      insurance coverage. Hence, unless you have an individual
                      health insurance policy, you will be over-burden with
                      exorbitant medical expenses.
                    </p>
                  </li>
                  <li className="liststyle">
                    <span className="specialprice">
                      SCENARIO 3: The Offered Corporate Coverage Is Exhausted
                    </span>
                    <p className="textformat">
                      As mentioned many a times, corporate health insurance
                      plans offer nominal coverage, especially if you have opted
                      for family coverage. The sum insured spread over your
                      family members won’t be worthy of the inflating medical
                      treatments all across India. Suppose your corporate plan
                      offers you a coverage of INR 10 lakhs and covers both your
                      parents and you. If you are aware of the inflation in the
                      medical industry, you already know the spiked costs of
                      healthcare services for older individuals and the senior
                      citizens health insurance policies are a respite. Now,
                      under some unfortunate circumstances, both your parents
                      need to be hospitalized consecutively, needing minor
                      surgery, do you honestly feel the 10 lakhs coverage
                      funding for it all? Without any individual health
                      insurance plan taken in your name and if your corporate
                      insurance coverage exhausted, medical bills will be
                      digging a deep hole into your pocket. This doesn’t look
                      like a wise financial decision.
                    </p>
                  </li>
                  <li className="liststyle">
                    <span className="specialprice">
                      SCENARIO 4: Everyone Needs Backup
                    </span>
                    <p className="textformat">
                      Corporate health insurance plans as a separate
                      freestanding policy can be insufficient, but on the other
                      hand, they are excellent support system. We will explain,
                      why? - You have availed of a wonderful individual plan
                      from one of the best insurance company. Each plan no
                      matter how popular comes with a waiting period. For this
                      span, where you wait for your individual coverage to kick
                      in, you can always bank on your corporate plan (that comes
                      with no waiting period). This is minimizing strain on your
                      financial liability while having access to premium
                      healthcare services.
                    </p>
                  </li>
                  <li className="liststyle">
                    <span className="specialprice">
                      SCENARIO 5: With Age The Insurance Becomes Pricey{" "}
                    </span>
                    <p className="textformat">
                      If you are continuing with your corporate health insurance
                      policy till the time you retire and then opting for an
                      individual health insurance plan, retirement states you
                      are above 60. Even with the best health insurance plans
                      for senior citizens, a humungous premium can only be
                      expected, along with a list of restrictions on the
                      features offered. Hence, with health insurance, the best
                      way would be to run a simultaneous corporate and
                      individual plan. And this wouldn’t be much of an issue
                      because, for the corporate, you are rarely paying a
                      premium. The only premium that you are bound to pay at a
                      go is for the individual plan. Now, if you choose any of
                      the best health insurance plan of 2023, the premium
                      becomes affordable along with useful and profitable perks,
                      and the claim settlement process becomes less-complicated
                      and convenient.
                    </p>
                  </li>
                </p>
              </div>

              <div className="redbtn">
                <button onClick={handlreadtwo} className="Readmorebtn">
                  {readmoreTab ? "Read More" : "Read Less"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PartnerCompany />
      <FAQ />
    </>
  );
};

export default IndividualHealthInsurance;
